import { useEffect, useRef } from "react";

export default function useTiltEffect({
  reverse = false,
  strength = 10,
  disable = false,
} = {}) {
  const ref = useRef();

  useEffect(() => {
    const element = ref?.current;

    if (!element || disable) {
      return;
    }

    const handleMouseEnter = () => {
      element.style.setProperty("transition", "none");
    };

    const handleMouseLeave = () => {
      element.style.setProperty("transition", "transform .6s .1s");
      element.style.removeProperty("--rY");
      element.style.removeProperty("--rX");
    };

    const handleMouseMove = (evt) => {
      const { width, height, top, left } = element.getBoundingClientRect();
      const { clientX, clientY } = evt;

      const x = -(clientX - left - width / 2) / strength;
      const y = (clientY - top - height / 2) / strength;

      element.style.setProperty("--rY", (reverse ? -1 * x : x).toFixed(2));
      element.style.setProperty("--rX", (reverse ? -1 * y : y).toFixed(2));
    };

    element.style.setProperty(
      "transform",
      "rotateX(calc(var(--rX) * 1deg)) rotateY(calc(var(--rY) * 1deg))"
    );
    element.addEventListener("mouseenter", handleMouseEnter);
    element.addEventListener("mouseleave", handleMouseLeave);
    element.addEventListener("mousemove", handleMouseMove);

    return () => {
      element.removeEventListener("mousemove", handleMouseMove);
      element.removeEventListener("mouseleave", handleMouseLeave);
      element.removeEventListener("mouseenter", handleMouseEnter);
      element.style.removeProperty("--rY");
      element.style.removeProperty("--rX");
      element.style.removeProperty("transition");
      element.style.removeProperty("transform");
    };
  }, [ref, disable]);

  return {
    ref,
    wrapperStyles: {
      transformStyle: "preserve-3d",
      transform: "perspective(100rem)",
    },
  };
}
